import { useEffect } from 'react';
import { EnvironmentData } from '@cld/unicorn-api';
import { ConsoleLogger } from '../types';

export const useLogUnicornConfiguration = ({ environmentData, consoleLogger }: { environmentData: EnvironmentData; consoleLogger: ConsoleLogger }) => {
  useEffect(() => {
    consoleLogger.debug('general', 'Environment detected', environmentData);
  }, [consoleLogger, environmentData]);
};
